import * as types from '../../actions';

const initialState = {
    masterDocItems: [],
    masterDocStatus:0,
    masterDocActivity:'',
    items: [],
    status:0,
    item:{
        id:'',
        name:'',
        isMandatory:false,
        showDateRange:false
    },
    activity:'',
    count:'',
    errorData:''      
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {

        case types.USER_DOC_MASTER_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    masterDocItems: response.data,
                    masterDocStatus: response.status,
                    masterDocActivity:types.USER_DOC_MASTER_LIST_SUCCESS,
                };
            }else{
                return {
                    ...state,
                    masterDocStatus: response.status,    
                    masterDocActivity:types.USER_DOC_MASTER_LIST_ERROR,                             
                };
            }

        case types.USER_DOC_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.USER_DOC_LIST_SUCCESS,
                    count:response.data.length
                };
            }else{
                return {
                    ...state,
                    status: response.status,    
                    activity:types.USER_DOC_LIST_ERROR,                             
                };
            }
       
        case types.USER_DOC_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.USER_DOC_ADD_SUCCESS,
                }   
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.USER_DOC_ADD_ERROR,
                    errorData: response.data,
                }   
            }           
        
        case types.USER_DOC_EDIT_SUCCESS: 
            if(response.status===200){        
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.name,
                        isMandatory:response.data.is_mandatory,
                        showDateRange:response.data.date_range
                    },
                    status: response.status,
                    activity:types.USER_DOC_EDIT_SUCCESS,               
                }  
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.USER_DOC_EDIT_ERROR,         
                }   
            }           

        case types.USER_DOC_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.USER_DOC_UPDATE_SUCCESS,         
                }    
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.USER_DOC_UPDATE_ERROR,  
                    errorData: response.data,       
                }   
            }       
        case types.USER_DOC_DELETE_SUCCESS:
            const id = response.data.id;  
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),                
                    status: response.status,
                    activity:types.USER_DOC_DELETE_SUCCESS,   
                }     
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.USER_DOC_DELETE_ERROR,     
                    errorData: response.data,    
                }   
            }              

        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name:'',
                    isMandatory:false,
                    showDateRange:false
                },
                activity:'',
                status:0,
                masterDocStatus: 0,
                masterDocActivity:'',                
            }  

        default:
            return state;
    }
  };